/* Announcement bar (§8.1): rolls messages on an interval; pauses on hover, focus or the pause
   button; reduced motion shows the first message only until the visitor presses play. */
class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.messages = [...this.querySelectorAll('[data-message]')];
    if (this.messages.length < 2) return;
    this.index = 0;
    this.hold = false;
    this.button = this.querySelector('[data-ann-pause]');

    this.onEnter = () => (this.hold = true);
    this.onLeave = (event) => {
      if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
      this.hold = false;
    };
    this.onToggle = () => this.setPaused(!this.paused);
    this.onBlockSelect = (event) => {
      const index = this.messages.indexOf(event.target);
      if (index === -1) return;
      this.show(index);
      this.setPaused(true);
    };

    this.addEventListener('pointerenter', this.onEnter);
    this.addEventListener('pointerleave', this.onLeave);
    this.addEventListener('focusin', this.onEnter);
    this.addEventListener('focusout', this.onLeave);
    if (this.button) this.button.addEventListener('click', this.onToggle);
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.setPaused(!(window.Theme && window.Theme.motionAllowed()));
    this.timer = setInterval(() => {
      if (!this.paused && !this.hold && !document.hidden) this.show(this.index + 1);
    }, Number(this.dataset.interval) || 4000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  show(index) {
    const count = this.messages.length;
    const next = (index + count) % count;
    this.messages.forEach((message, i) => {
      const active = i === next;
      message.classList.toggle('is-active', active);
      message.classList.toggle('is-past', i === this.index && !active);
      message.toggleAttribute('inert', !active);
      message.setAttribute('aria-hidden', String(!active));
    });
    this.index = next;
  }

  setPaused(paused) {
    this.paused = paused;
    if (this.button) this.button.setAttribute('aria-pressed', String(paused));
  }
}

if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);
